<template>
  <div class="page login-page">
    <div class="login-content">
      <van-nav-bar class="nav-bar" :title="$t('auth.register')" :border="false" placeholder>
        <template #left>
          <van-icon name="arrow-left" color="#fff" size="24" @click="back()" />
        </template>
      </van-nav-bar>

      <div class="form-wrap">
        <div class="form-title">{{ $t("auth.register") }}</div>

        <div class="form-fields">
          <van-field
            v-model="username"
            clearable
            class="input-large"
            :placeholder="$t('auth.username_place')"
          >
            <template #left-icon><van-icon name="user-o" /></template>
          </van-field>

          <van-field
            v-model="password"
            :type="passwordType"
            class="input-large"
            :placeholder="$t('auth.pwd_place')"
          >
            <template #left-icon><van-icon name="lock" /></template>
            <template #right-icon>
              <van-icon
                :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                @click="switchPasswordType"
              />
            </template>
          </van-field>

          <van-field
            v-model="code"
            clearable
            class="input-large"
            :placeholder="$t('auth.invite_code_place')"
          >
            <template #left-icon><van-icon name="coupon-o" /></template>
          </van-field>

          <van-button 
            class="btn-large-primary" 
            :loading="isSubmitting" 
            loading-type="spinner"
            @click="doRegister()"
          >
            {{ $t("auth.register") }}
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checked: true,
      username: '',
      code: '',
      lang: 'en_us',
      password: '',
      passwordType: 'password',
      // password1: '',  // <-- 已移除提款密码字段
      isSubmitting: false, // 按钮加载状态
    };
  },
  mounted() {
    this.lang = localStorage.getItem("lang") || 'es_spa';
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
    },
    back() {
      return window.history.back();
    },
    doRegister() {
      if (!this.username) {
        this.$toast.fail(this.$t("auth.username_place"));
        return false;
      }
      if (!this.password) {
        this.$toast.fail(this.$t("auth.pwd_place"));
        return false;
      }
      if (!this.code) {
        this.$toast.fail(this.$t("auth.invite_code_place"));
        return false;
      }

      this.isSubmitting = true; // 开启加载动画

      this.$http({
        method: 'post',
        url: 'member_register',
        data: {
          username: this.username,
          password: this.password,
          // password1: this.password1, <-- 已移除提款密码参数
          code: this.code,
          lang: this.lang
        }
      }).then(res => {
        this.isSubmitting = false; // 关闭加载动画
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem('token', res.data);
          this.$router.push("Mine");
        } else {
          this.$toast.fail(res.msg);
        }
      }).catch(() => {
        this.isSubmitting = false;
        this.$toast.fail("网络请求失败，请稍后重试");
      });
    }
  }
};
</script>

<style lang="less" scoped>
.login-page {
  position: relative;
  min-height: 100vh;
  background: url('/img/login/login.png') no-repeat center center;
  background-size: cover;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(8, 7, 24, 0.08) 0%, rgba(8, 7, 24, 0.38) 58%, rgba(8, 7, 24, 0.62) 100%);
    pointer-events: none;
  }
}

.login-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.nav-bar {
  background: transparent !important;
  ::v-deep .van-nav-bar__content {
    height: 60px;
  }
}

.form-wrap {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start; 
  /* 因为少了一个输入框，调整回和登录页一样的 22vh，保持页面统一 */
  padding: 22vh 24px 0; 
}

.form-title {
  font-size: 34px;
  font-weight: bold;
  color: #ffffff; 
  text-align: center;
  margin-bottom: 32px;
  letter-spacing: 2px;
  text-shadow: 0 3px 12px rgba(0,0,0,0.55); 

  &::after {
    content: '';
    display: block;
    width: 48px;
    height: 4px;
    margin: 14px auto 0;
    border-radius: 4px;
    background: #7180ff;
    box-shadow: 0 0 14px rgba(113, 128, 255, 0.65);
  }
}

.form-fields {
  width: 100%;
  max-width: 440px; 
  margin: 0 auto;
}

/* 放大版的深色半透明输入框 */
.input-large {
  min-height: 66px;
  background: rgba(37, 36, 56, 0.82) !important;
  border-radius: 60px; 
  margin-bottom: 20px; 
  padding: 20px 28px; 
  border: 1px solid rgba(255, 255, 255, 0.13); 
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.2); 
  transition: border-color 0.25s ease, box-shadow 0.25s ease;

  &:focus-within {
    border-color: rgba(124, 135, 255, 0.95);
    box-shadow: 0 0 0 4px rgba(91, 108, 242, 0.16), 0 8px 22px rgba(0, 0, 0, 0.22);
  }

  ::v-deep .van-field__left-icon {
    display: flex;
    align-items: center;
    margin-right: 14px;

    .van-icon {
      color: #a9b0ff;
      font-size: 32px;
    }
  }
  
  ::v-deep .van-field__control {
    font-size: 32px; 
    line-height: 26px;
    color: #ffffff; 
  }

  ::v-deep .van-field__control::placeholder {
    color: #a0a0ab; 
  }

  ::v-deep .van-field__right-icon {
    position: absolute;
    right: 24px;
    .van-icon {
      font-size: 32px; 
      color: #a9b0ff; 
    }
  }
}

/* 放大版的按钮 */
.btn-large-primary {
  width: 100%;
  height: 62px; 
  border-radius: 60px;
  background: linear-gradient(100deg, #6878f6, #5268ee); 
  color: #ffffff;
  border: none;
  font-size: 32px; 
  font-weight: 600;
  margin-top: 16px;
  margin-bottom: 24px;
  box-shadow: 0 10px 24px rgba(72, 91, 224, 0.42);
  transition: all 0.3s ease;
  
  &:active { 
    opacity: 0.85;
    transform: scale(0.98);
  }
}

@media (max-height: 720px) {
  .form-wrap {
    padding-top: 10vh;
    padding-bottom: 24px;
  }

  .form-title {
    margin-bottom: 22px;
  }

  .input-large {
    margin-bottom: 15px;
  }
}
</style>
